import { reduce } from '@antv/util';
/**
 * 在 Chart 中查找第一个指定 type 类型的 geometry
 * @param chart
 * @param type
 */
export function findGeometry(chart, type) {
    return chart.geometries.find(function (g) { return g.type === type; });
}
/**
 * 获取 Chart 的 所有 elements
 */
export function getAllElements(chart) {
    return reduce(chart.geometries, function (r, geometry) {
        return r.concat(geometry.elements);
    }, []);
}
//# sourceMappingURL=geometry.js.map